import PaymentDate from './PaymentDate';

export default PaymentDate;
